import React, { Component } from 'react';
import { Container } from 'flux/utils';
import { Link } from 'react-router';
import { statusColours } from '../../constants/ColourConstants';
import { asCard } from '../Common/Decorators';
import { CardActions, CardHeader } from 'material-ui/Card';
import Divider from 'material-ui/Divider';
import FlatButton from 'material-ui/FlatButton';
import LibraryIcon from 'material-ui/svg-icons/maps/local-library';

import StatStore from '../../stores/StatStore';
import { StatTypes } from '../../constants/CentricConstants';
import CourseActions from '../../actions/CourseActionCreator';
import ModuleActions from '../../actions/ModuleActionCreator';

const LibraryWidgetView = ({...data}) => {

    const subtitle = ['courses', 'modules', 'resources']
        .filter(type => !!data[type])
        .map(type => `${data[type]} ${type}`)
        .join(', ');

    return (
        <section>
            <CardHeader
                title={<Link to="/dashboard/library" >Library</Link>}
                subtitle={subtitle}
                avatar={<Link to="/dashboard/library" ><LibraryIcon color={statusColours.default} /></Link>}
            />
            <Divider />
            <CardActions>
                <FlatButton label="Visit Library" href="/dashboard/library" />
            </CardActions>
        </section>
    );
};


class LibraryWidgetContainer extends Component {

    componentDidMount() {
        CourseActions.getCount();
        ModuleActions.getModuleCount();
        ModuleActions.getResourceCount();
    }

    render() {
        return <LibraryWidgetView {...this.state} />;
    }

}

const sanitise = (stats) => ({
    courses:        Number(stats.get(StatTypes.COURSE_COUNT)) || 0,
    modules:        Number(stats.get(StatTypes.MODULE_COUNT)) || 0,
    resources:      Number(stats.get(StatTypes.RESOURCE_COUNT)) || 0,
});

LibraryWidgetContainer.getStores = () => ([StatStore]);
LibraryWidgetContainer.calculateState = (prevState = {}) => ({
    ...prevState,
    ...sanitise(StatStore.getState())
});

export default asCard(Container.create(LibraryWidgetContainer));
